<script setup>
import { TriangleAlert, } from 'lucide-vue-next';
</script>
<template>
  <div class="py-3">
    <div
      class="flex gap-3 bg-amber-50 border-l-4 border-amber-500 px-4 py-3 rounded-r-md items-center"
      role="alert"
    >
      <TriangleAlert class="mt-0.5 shrink-0 text-amber-700" />

      <div class="flex flex-col">
        <p class="text-sm font-bold text-amber-900">
          Scheduled maintenance
        </p>
        <p class="text-sm text-amber-800">
          We're performing scheduled maintenance to improve your experience. This option will be available within 3 hours. Thank you for your patience.
        </p>
      </div>
    </div>
  </div>
</template>
